module.exports = __webpack_public_path__ + "static/media/apple-ipad.25f0ee4d.png";